import { render, staticRenderFns } from "./RegisterKitchenView.vue?vue&type=template&id=fc4bcf0e"
import script from "./RegisterKitchenView.vue?vue&type=script&lang=js"
export * from "./RegisterKitchenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports